export default {
  id: 163,
  title: 'Target #163 - Missing Piece',
  url: 'https://cssbattle.dev/play/163',
  colors: ['#D669EC', '#FDFBF8'],
  solution:
    '<a a><a b><style>[a],[b]{width:100;height:100}[b],body{background:#d669ec}a{position:fixed}[a]{top:40;left:90;background:#fdfbf8;box-shadow:120px 0 #fdfbf8,0 120px #fdfbf8}[b]{top:100;left:26;transform:rotate(-45deg);box-shadow:175px 0 #d669ec,0 175px #d669ec,175px 175px #d669ec}</style>',
}
